import { render, staticRenderFns } from "./aufgaben-dateien.vue?vue&type=template&id=57e2234e&scoped=true"
import script from "./aufgaben-dateien.vue?vue&type=script&lang=js"
export * from "./aufgaben-dateien.vue?vue&type=script&lang=js"
import style0 from "./aufgaben-dateien.vue?vue&type=style&index=0&id=57e2234e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e2234e",
  null
  
)

export default component.exports